import React from 'react';
import './LearnPage.css';

const LearnPage = () => {
  // 扩展后的课程数据
  const lessons = [
    { id: 1, title: '01. 节奏与律动的基石', duration: '14:20', icon: 'fa-drum', color: 'blue', status: 'completed' },
    { id: 2, title: '02. 和弦构成三要素', duration: '08:45', icon: 'fa-music', color: 'purple', status: 'playing' },
    { id: 3, title: '03. 流行和弦进行 4536', duration: '12:30', icon: 'fa-guitar', color: 'orange', status: 'locked' },
    { id: 4, title: '04. 旋律线的起伏设计', duration: '15:10', icon: 'fa-wave-square', color: 'green', status: 'locked' },
    { id: 5, title: '05. 贝斯：低音的灵魂', duration: '11:00', icon: 'fa-bolt', color: 'gray', status: 'locked' },
    { id: 6, title: '06. 鼓组编配进阶', duration: '18:20', icon: 'fa-drum-steelpan', color: 'gray', status: 'locked' },
    { id: 7, title: '07. 混音：空间感的塑造', duration: '22:15', icon: 'fa-sliders-h', color: 'gray', status: 'locked' },
    { id: 8, title: '08. 母带处理初探', duration: '09:40', icon: 'fa-compact-disc', color: 'gray', status: 'locked' },
    { id: 9, title: '09. 音乐发行全流程', duration: '13:55', icon: 'fa-globe', color: 'gray', status: 'locked' },
  ];

  const handleItemClick = (lesson) => {
    console.log(`Clicked lesson: ${lesson.title}`);
  };

  return (
    <div className="learn-page">
      {/* 简单的页面头部 */}
      <div className="page-header">
        <h1>我的课程</h1>
        <p>保持学习节奏，每天进步一点点</p>
      </div>

      {/* 顶部大卡片：当前正在学的课程 */}
      <div className="course-banner">
        <div className="banner-circle"></div>
        <div className="banner-content">
          <span className="course-tag">进行中</span>
          <h2 className="banner-title">全能音乐制作人：<br/>从零开始的编曲课</h2>
        </div>
        
        <div className="course-progress-container">
          <div className="progress-info">
            <span>已学习 35%</span>
            <span>2/15 课时</span>
          </div>
          <div className="progress-track">
            <div className="progress-fill" style={{ width: '35%' }}></div>
          </div>
        </div>
      </div>

      {/* 课程列表 */}
      <div className="lesson-section">
        <div className="section-title">
            目录
            <span>共 9 节课</span>
        </div>
        
        <div className="lesson-list">
          {lessons.map((lesson) => (
            <div 
              key={lesson.id} 
              className="lesson-item" 
              onClick={() => handleItemClick(lesson)}
            >
              {/* 左侧图标 */}
              <div className={`icon-box icon-bg-${lesson.color === 'gray' ? 'gray' : lesson.color}`}>
                <i className={`fa-solid ${lesson.icon}`}></i>
              </div>

              {/* 中间信息 */}
              <div className="lesson-info">
                <h3 className="lesson-title">{lesson.title}</h3>
                <span className="lesson-meta">
                    {lesson.status === 'locked' ? '待解锁' : `时长 ${lesson.duration}`}
                </span>
              </div>

              {/* 右侧状态指示 */}
              <div className={`lesson-status ${lesson.status}`}>
                {lesson.status === 'completed' && <i className="fa-solid fa-check"></i>}
                {lesson.status === 'playing' && <i className="fa-solid fa-play"></i>}
                {lesson.status === 'locked' && <i className="fa-solid fa-lock"></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LearnPage;